import React from 'react'
import { Container, Row, Col, Card, Button } from 'react-bootstrap'
import { UpcomingCards } from '../components/UpcomingCards'
import EntriesTable from '../components/EntriesTable'
import CurrentRace from '../components/CurrentRace'
import Utility from '../utilities/Utilities'
import './styles/Control.css'
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../Firebase/firebase';

export default class RaceController extends React.Component {
    constructor(props) {
        super(props);
        this.docRef = doc(db, 'meetstatus', this.props.team);
    }

    changeRace = (differential, max) => {
        const next = Math.max(-1, Math.min(this.props.currentstart + differential, max));
        updateDoc(this.docRef, { currentstart: next });
    };

    render() {
        return (
            this.props.heatsheet ?
                <Container fluid={true} className="control-body">
                    <Row style={{ minHeight: '3vh' }} />
                    <Row>
                        <Col xs={12} md={6} className="race-card-col">
                            <Card>
                                <Card.Header className="controlTableTitle">
                                    <CurrentRace heatsheet={this.props.heatsheet} raceNo={this.props.currentstart} />
                                    : {Utility.getStrokeLongText(true, true, true, true, this.props.heatsheet, this.props.currentstart)}
                                </Card.Header>
                            </Card>
                            <EntriesTable data={this.props.heatsheet} raceNo={this.props.currentstart}/>
                        </Col>
                        <Col xs={12} md={6} className="race-card-col">
                            <Card>
                                <Card.Header className="controlTableTitle">
                                    <CurrentRace heatsheet={this.props.heatsheet} raceNo={this.props.currentstart + 1} />
                                    : {Utility.getStrokeLongText(true, true, true, true, this.props.heatsheet, this.props.currentstart + 1)}
                                </Card.Header>
                            </Card>
                            <EntriesTable data={this.props.heatsheet} raceNo={this.props.currentstart + 1}/>
                        </Col>
                    </Row>
                    <Row className="raceControllerButtonDeck">
                        <Col xs={6} md={{span:4, offset:2}}>
                            <Button className="race-controller-action w-100" onClick={() => this.changeRace(-1, this.props.heatsheet.starts.length)}>Previous</Button>
                        </Col>
                        <Col xs={6} md={4}>
                            <Button className="race-controller-action w-100" onClick={() => this.changeRace(1, this.props.heatsheet.starts.length)}>Next</Button>
                        </Col>
                    </Row>
                    <Row style={{ minHeight: '2vh' }} />
                    <Row>
                        <Col>
                            <div className="bottom-deck">
                                <UpcomingCards {...this.props} />
                            </div>
                        </Col>
                    </Row>
                    <Row style={{ minHeight: '2vh' }} />
                </Container>
            :
                <Container fluid={true} style={{ textAlign: 'center' }}>
                    <Row style={{ minHeight: '40vh' }} />
                    <Row>
                        <Col>
                            <div>No heatsheet is currently active.</div>
                            <div>You can upload or activate one in <a href={`/${this.props.team}/console/admin`}>Admin</a> on your Cruiser Console.</div>
                        </Col>
                    </Row>
                    <Row style={{ minHeight: '1vh' }}/>
                    <Row>
                        <Col>
                            <Button href={`/${this.props.team}/console/admin`}>Go to Admin</Button>
                        </Col>
                    </Row>
                </Container>
        );
    }
}
